<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-notifications-view :notificationStatuses="notificationStatuses" />

    <core-footer />

  </v-app>
</template>

<script>

export default {
  name: 'Notifications',
  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreNotificationsView: () => import('../components/core/NotificationsView'),
    CoreFooter: () => import('../components/core/Footer'),
  },
  data: () => ({
    expandOnHover: false,
    notificationStatuses: []
  }),
}
</script>
